import {
  Card, CardContent, CardHeader,
  CircularProgress, Paper, Container, colors,
  DialogActions, DialogTitle, DialogContent, Dialog, Slider, LinearProgress, Button, Input, Select, Option,
  Divider, Grid, CardActions, FormControl, InputAdornment, TextField, TableSortLabel, TablePagination, Slide,
  TableContainer, Table, TableHead, TableCell, TableRow, TableBody, CardMedia, Tabs, Tab, Backdrop, Typography, Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from "src/utils/axios";
import React, { useEffect, UseState } from 'react';
import Page from 'src/components/Page';
import ImageAcceptIcon from '@material-ui/icons/ThumbUp';
import ImageRejectIcon from '@material-ui/icons/ThumbDown';
import { getUser, CreateWareHouseAddress } from 'src/utils/Common';
import MuiAlert from '@material-ui/lab/Alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import BorderOuterIcon from '@material-ui/icons/BorderOuter';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultUyari = { open: false, aciklama: '', tip: 'success' };






function CardSave() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = React.useState(defaultUyari);

  const user = getUser();


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


  const SetCardSave = () => {
    // setLoading(true);
    // axios.get(`/SetCardSave/${user.ServiceShopId}`)
    //   .then((response) => {
    //     const res = response.data;
    //     window.open(res, '_blank');
    //     setLoading(false);
    //   }).catch(error => {
    //     setLoading(false);
    //   });
    //serdr
    const today = moment(new Date()).format('DD.MM.YYYY');
    const data = [{
      conversationId: user.ServiceShopCode + today.toString(),
      price: 1,
      paidPrice: 1,
      installment: 1,
      currency: "TRY",
      paymentGroup: "PRODUCT",
      callbackUrl: "NO_CALLBACK_URL", //bURASI NASIL YAPILACAK SORULACAK.
      items: [
        {
          externalId: user.ServiceShopCode,
          name: "KART KAYIT",
          price: 1,
          subMerchantId: user.TokenPayId,
          subMerchantPrice: 1
        }
      ]
    }
    ]

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/PostTokenPayUrl', data, config)
      .then(response => {
        setLoading(false);
        if (response.data.substring(0,5) === "https"){
          window.open(response.data);
        }else{
          alert("Ödero Sisteminden Sözleşmeleri Onaylamanız Gerekiyor!....");
        }
        
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }



  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Kredi Kartı Kayıt Sayfası"></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => SetCardSave()}
              endIcon={<BorderOuterIcon>Getir</BorderOuterIcon>}
            >
              Kredİ Kartı Kayıt Sayfasına Yönlendir...
            </Button>
          </CardContent>

        </Card>

      </Container>

    </Page>
  );
}

export default CardSave;
